/**
 * defa.collections.warmup
 * A Collection of Warmup
 * @version 1.0.0
 */
import Warmup from 'scripts/defa/unit-feature-sets/endpoints/warmup/model-warmup';

const Warmups = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : Warmup,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default Warmups;